import React from 'react';
import PropTypes from 'prop-types';

import { HelperText } from '../../styles';
import text from '../../text.json';

/**
 * Helper text under the broadcast "send even if unread messages" switch. The copy depends on
 * the switch state, and the ON state is shown in the warning colour because it overrides the
 * unread-message check that normally holds a broadcast back as a draft.
 */
const ForceSendHelperText = ({ isForceSendEnabled }) => (
  <HelperText $isWarning={isForceSendEnabled}>
    {isForceSendEnabled ? text.forceSendHelperOn : text.forceSendHelperOff}
  </HelperText>
);

ForceSendHelperText.propTypes = {
  isForceSendEnabled: PropTypes.bool.isRequired,
};

export default ForceSendHelperText;
